import './new-holiday-type.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateHolidayType } from "@core/query/holiday-type.query";
import { HolidayTypeFormRule, HolidayTypeFormSchema } from "@core/form/form.rule";
import { holidayTypeFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormHolidayType from "../form-holiday-type/form-holiday-type";

export function HolidayType() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateHolidayType } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New HolidayType is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addHolidayType, isLoading: isCreating } =
    useQyCreateHolidayType(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<HolidayTypeFormSchema>({
    defaultValues: holidayTypeFormDefault,
    resolver: zodResolver(HolidayTypeFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: HolidayTypeFormSchema) => {
    const formData = mapCreateHolidayType(form);
    addHolidayType(formData);
  };
  const handleValidateError = (err: FieldErrors<HolidayTypeFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="HolidayType" className="holiday-type">
      <HeaderContent
        title="New HolidayType"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormHolidayType />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default HolidayType;